import Homescreen_icon from '../../home/assets/Homescreen.png';
import { AuthLayout } from '../components';
import { ResetPasswordForm } from '../components/ResetPassword/ResetPasswordForm';
import { AUTH_TITLE_CLASS, AUTH_SUBTITLE_CLASS } from '../lib/authStyles';

export function ResetPasswordPage() {
  return (
    <AuthLayout rightImage={Homescreen_icon} rightAlt="Aexon Assistant Mockup">
      <h1 className={AUTH_TITLE_CLASS}>Create New Password</h1>
      <h2 className={AUTH_SUBTITLE_CLASS}>
        Enter a new password for your account
      </h2>
      <div className="animate-fadeIn">
        <ResetPasswordForm />
      </div>
    </AuthLayout>
  );
}
